import axios from '@/util/request'

// 角色管理

// /com/had-login/sys/sys-role/addOrUpdateRole
// 新增或编辑角色类型的信息和权限
export const addOrUpdateRole = (data) => {
  return axios({
    url: '/com/had-login/sys/sys-role/addOrUpdateRole',
    method: 'post',
    data
  })
}

// /com/had-login/sys/sys-menu/getAllMenu
// 全部菜单，树形结构
export const getModulePermission = (params) => {
    return axios({
      url: '/com/had-login/sys/sys-menu/getAllMenu',
      method: 'get',
      params
    })
  }

// /com/had-login/sys/sys-role/rolePage
// 角色的分页查询
export const rolePage = (data) => {
    return axios({
      url: '/com/had-login/sys/sys-role/rolePage',
      method: 'post',
      data
    })
  }

//   /com/had-login/sys/sys-role/trueAndFalse
// 开启或停用角色类型，多个用，隔开
export const trueAndFalse = (params) => {
    return axios({
      url: '/com/had-login/sys/sys-role/trueAndFalse',
      method: 'get',
      params
    })
  }

//   /com/had-login/sys/sys-role/getRoleDetail
//   获取角色详情
export const getRoleDetail = (params) => {
    return axios({
      url: '/com/had-login/sys/sys-role/getRoleDetail',
      method: 'get',
      params
    })
  }

//   省份管理

// /com/had-login/sys/sys-province/getYears
// 查询年份
export const getYears = (params) => {
    return axios({
      url: '/com/had-login/sys/sys-province/getYears',
      method: 'get',
      params
    })
  }

//   /com/had-login/sys/sys-province/saveYear
// 添加年份
export const saveYear = (params) => {
  return axios({
    url: '/com/had-login/sys/sys-province/saveYear',
    method: 'get',
    params
  })
}

// /com/had-login/sys/sys-province/saveProvince
// 省份新增/编辑
export const saveProvince = (data) => {
  return axios({
    url: '/com/had-login/sys/sys-province/saveProvince',
    method: 'post',
    data
  })
}

// /com/had-login/sys/sys-province/getProvincePage
// 省份查询列表
export const getProvincePage = (data) => {
  return axios({
    url: '/com/had-login/sys/sys-province/getProvincePage',
    method: 'post',
    data
  })
}

// /com/had-login/sys/sys-province/getProvinceInfo
// 省份查询详情
export const getProvinceInfo = (params) => {
  return axios({
    url: '/com/had-login/sys/sys-province/getProvinceInfo',
    method: 'get',
    params
  })
}


//系统日志

// /com/had-login/logs/page
// 分页查询系统日志
export const page = (data) => {
  return axios({
    url: '/com/had-login/logs/page',
    method: 'post',
    data
  })
}

// /com/had-login/sys/company/getCompanyDetail
// 查询公司详情
export const getCompanyDetail = (params) => {
  return axios({
    url: '/com/had-login/sys/company/getCompanyDetail',
    method: 'get',
    params
  })
}

// /com/had-login/sys/sys-batch/getBatchPage
// 批次查询列表
export const getBatchPage = (data) => {
  return axios({
    url: '/com/had-login/sys/sys-batch/getBatchPage',
    method: 'post',
    data
  })
}

// /com/had-login/sys/sys-batch/saveBatch
// 批次新增/编辑
export const saveBatch = (data) => {
  return axios({
    url: '/com/had-login/sys/sys-batch/saveBatch',
    method: 'post',
    data
  })
}

// /com/had-login/sys/sys-batch/deletetBatch
// 删除改批次
export const deletetBatch = (params) => {
  return axios({
    url: '/com/had-login/sys/sys-batch/deletetBatch',
    method: 'get',
    params
  })
}
// /com/had-login/sys/sys-batch/setBatchState
// 修改批次状态
export const setBatchState = (params) => {
  return axios({
    url: '/com/had-login/sys/sys-batch/setBatchState',
    method: 'get',
    params
  })
}

// /com/had-login/sys/sys-province/getOneProvince
// 根据年份和省份(地区)id查询单个
export const getOneProvince = (params) => {
  return axios({
    url: '/com/had-login/sys/sys-province/getOneProvince',
    method: 'get',
    params
  })
}

// /com/had-login/sys/sys-province/getprovinceBatchaspirationById
// 通过省份的批次id查询志愿的分数范围
export const getprovinceBatchaspirationById = (params) => {
  return axios({
    url: '/com/had-login/sys/sys-province/getprovinceBatchaspirationById',
    method: 'get',
    params
  })
}

// 统一设置招生计划时间
// /com/had-login/sys/sys-province/setPlanDate
export const setPlanDate = (params) => {
  return axios({
    url: '/com/had-login/sys/sys-province/setPlanDate',
    method: 'get',
    params
  })
}

// 菜单排序
// /com/had-login/sys/sys-menu/updateSort
export const updateSort = (params) => {
  return axios({
    url: '/com/had-login/sys/sys-menu/updateSort',
    method: 'get',
    params
  })
}

// /com/had-login/sys/sys-menu/saveMenu
// 新增或修改菜单按钮
export const saveMenu = (data) => {
  return axios({
    url: '/com/had-login/sys/sys-menu/saveMenu',
    method: 'post',
    data
  })
}

//关键字新增  com/sys-keyword/saveOrUpdateKeyword
export const addKeyowrd = (data) => {
  return axios({
    url: '/com/had-login/sys-keyword/saveOrUpdateKeyword',
    method: 'post',
    data
  })
}

//关键字列表 com/sys-keyword/getList
export const obtainKeyword = (params) => {
  return axios({
    url: '/com/sys-keyword/getList',
    method: 'get',
    params
  })
}

//关键字列表 com/sys-keyword/getList
export const keywordPageList = (data) => {
  return axios({
    url: '/com/had-login/sys-keyword/pageList',
    method: 'post',
    data
  })
}

//关键字删除 /had-login/sys-keyword/delete
export const deleteKeyowrd = (params) => {
  return axios({
    url: '/com/had-login/sys-keyword/delete',
    method: 'get',
    params
  })
}

//新增版本  com/had-login/admission/renew_info/save
export const addVersion = (data) => {
  return axios({
    url: '/com/had-login/version/renew_info/save',
    method: 'post',
    data
  })
}

//版本管理列表
export const obtainVersionList = (data) => {
  return axios({
    url: '/com/had-login/version/renew_info/queryPage',
    method: 'post',
    data
  })
}


//版本管理列表
export const deleteVersion = (data) => {
  return axios({
    url: '/com/had-login/version/renew_info/delete',
    method: 'post',
    data
  })
}

//获取IOS审核状态
export const getIOSAuditStatus = (params) => {
  return axios({
    url: '/com/had-login/version/renew_info/getIOSAuditStatus',
    method: 'get',
    params
  })
}

//设置IOS审核状态
export const setIOSAuditStatus = (data) => {
  return axios({
    url: '/com/had-login/version/renew_info/setIOSAuditStatus',
    method: 'post',
    data
  })
}

// /com/had-login/admission/admission-splan/synchronousInclusionSpecialty
// 包含-同步按钮 计划

export const synchronousPlanInclusionSpecialty = (data) => {
  return axios({
    url: '/com/had-login/admission/admission-splan/synchronousInclusionSpecialty',
    method: 'post',
    data,
    timeout: 0,
    noLoading: true
  })
}

// 包含-同步按钮 录取数据

export const synchronousAdmissionInclusionSpecialty = (data) => {
  return axios({
    url: '/com/had-login/admission/admission-college/synchronousInclusionSpecialty',
    method: 'post',
    data,
    timeout: 0,
    noLoading: true
  })
}

// 同步分数范围
export const unifiedSettingOfScoreRange = (data) => {
  return axios({
    url: '/com/had-login/sys/sys-province/unifiedSettingOfScoreRange',
    method: 'post',
    data,
    timeout: 0,
    noLoading: true
  })
}